import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { IMaskInput } from 'react-imask';
import classNames from 'classnames';
import { useRef } from 'react';

export type NumberIntProps = VFFieldProps<
  React.ComponentProps<typeof IMaskInput>
>;
export const MaskNumber = React.forwardRef<HTMLInputElement, NumberIntProps>(
  ({
    name,
    validate,
    className,
    inputClassName,
    label,
    disabled,
    required,
    ...other
  }) =>
    /*,
    ref*/
    {
      const inputRef = useRef<any>();
      const tempValue = useRef<any>('');

      return (
        <FormItem
          name={name}
          className={className}
          label={label}
          required={required}
          disabled={disabled}
        >
          <Field name={name} validate={validate}>
            {({
              input: { value, onChange, onBlur, name, ...nother },
            }: FieldRenderProps<number>) => {
              const handleBlur = () => {
                const val: string = value?.toString();
                let updatedValue;

                // console.log('BLUR - current temp', tempValue.current);
                if (tempValue.current !== '-0' && tempValue.current !== '+0') {
                  if (val != '') {
                    if (val[0] === '+') {
                      updatedValue = val.substring(1);
                      inputRef.current.value = updatedValue;
                    } else if (
                      val[0] === '-' &&
                      parseFloat(val.substring(1)) === 0
                    ) {
                      updatedValue = '0';
                      inputRef.current.value = updatedValue;
                    } else {
                      updatedValue = val;
                    }
                    // num = value;
                    // inputRef.current.value = num.toString();
                  } else {
                    updatedValue = val;
                  }
                } else {
                  updatedValue = '0';
                }

                const realVal = updatedValue
                  ? parseFloat(updatedValue)
                  : undefined;
                // onChange(updatedValue);
                onChange(realVal);
                onBlur({
                  target: { name, value: updatedValue },
                } as any as React.FocusEvent<HTMLElement>);
              };

              const handleChange = (value: any) => {
                tempValue.current = value;

                if (value !== '-0' && value !== '+0') {
                  const realVal = value ? parseFloat(value) : undefined;
                  // console.log('CHANGE', value, realVal);
                  // onChange(value);
                  onChange(realVal);
                }
              };

              return (
                <IMaskInput
                  {...other}
                  {...nother}
                  value={value?.toString()}
                  unmask={true} // true|false|'typed'
                  inputRef={(x: any) => {
                    inputRef.current = x;
                  }}
                  disabled={disabled}
                  name={name}
                  className={classNames(inputClassName, 'bp3-fill bp3-input')}
                  // DO NOT USE onChange TO HANDLE CHANGES!
                  // USE onAccept INSTEAD
                  onBlur={handleBlur}
                  onAccept={
                    // depending on prop above first argument is
                    // `value` if `unmask=false`,
                    // `unmaskedValue` if `unmask=true`,
                    // `typedValue` if `unmask='typed'`
                    handleChange
                  }
                  // ...and more mask props in a guide
                  // input props also available
                  // placeholder="Enter number here"
                />
              );
            }}
          </Field>
        </FormItem>
      );
    }
);
